import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _registerUser(options={}) {
	return _apiRequestWrap(ModulesMap.AUTH, ModulesConfigMap[ModulesMap.AUTH].REGISTER_USER, options)
}

function _loginUser(options={}) {
	return _apiRequestWrap(ModulesMap.AUTH, ModulesConfigMap[ModulesMap.AUTH].LOGIN_USER, options)
}

function _resendEmailConfirmation(options={}) {
	return _apiRequestWrap(ModulesMap.AUTH, ModulesConfigMap[ModulesMap.AUTH].RESEND_EMAIL_CONFIRMATION, options)
}

export default {
	registerUser: _registerUser,
	loginUser: _loginUser,
	resendEmailConfirmation: _resendEmailConfirmation
}
